import React, { Fragment } from "react";
import { Image } from "react-bootstrap";

import { usFormatPhoneNumber } from "../../../../utils";

import classes from "./ContactAlert.module.css";

import callAlert from "../../../../assets/images/call-alert.svg";
import errorImage from "../../../../assets/images/icon-error.svg";

interface Props {
  modalClosed: () => void;
  contactNumber?: string | null;
  website?: string | null;
}

export const Contact: React.FunctionComponent<Props> = (props) => {
  const { modalClosed, contactNumber } = { ...props };
  return (
    <Fragment>
      <div className={classes.popupBody}>
        <div className={classes.closeBtn} onClick={modalClosed}>
          X
        </div>
        <h6>Please reach out to below Contact Number</h6>
        <div className={classes.callAlert}>
          <h3>
            <Image src={callAlert} alt="call alert" />
            {contactNumber
              ? usFormatPhoneNumber(contactNumber)
              : "Phone Number Not Available"}
          </h3>
        </div>
      </div>
    </Fragment>
  );
};
export const WebsiteAlert: React.FunctionComponent<Props> = (props) => {
  const { modalClosed } = { ...props };
  return (
    <Fragment>
      <div className={classes.popupBody}>
        <div className={classes.closeBtn} onClick={modalClosed}>
          X
        </div>
        <div className={classes.networkAlert}>
        <Image
          src={errorImage}
          alt={errorImage}
          className={classes.errorImage}
        />
          <h4>
          {/* <Image src={websiteAlert} alt="website alert" /> */}
            Website Not Available
          </h4>
        </div>
      </div>
    </Fragment>
  );
};
